export enum Roles {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  ATM = 3,
  WAITRESS = 4,
  CHEF = 5,
  BAR = 6,
  COUNTER=7 ,
  PROVIDER=8  ,
  LINE=9  ,
  OWNER_SOFT=1000
}


export const rolsByRestaurant = [Roles.ATM,Roles.BAR,Roles.CHEF, Roles.WAITRESS];
export const rolsByOtherCompany = [Roles.ATM]